// extracted by mini-css-extract-plugin
module.exports = {"Card":"Card_Card__8nnZR","LayoutVertical":"Card_LayoutVertical__P4Dj1","LayoutHorizontal":"Card_LayoutHorizontal__3r_57"};